// Copyright (c) Bentley Systems
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "./store";
import { DEFAULT_COLOR } from "../Helpers/constants";

type EntrySreenState = {
  //iTwinId and iModelId are defined in queryUrl, checking method in EntryScreen.tsx
  isUrlValid: boolean;
  isImodelValueDefined: boolean;
  createIModelValue: boolean;
  intelligentContent: boolean;
  defaultColor: string;
  isCreatingIModelValue: boolean;
  iModelDescription?: string;
  iModelValueId?: number;
};

const initialState: EntrySreenState = {
  isUrlValid: false,
  isImodelValueDefined: true,
  createIModelValue: false,
  intelligentContent: false,
  defaultColor: DEFAULT_COLOR,
  isCreatingIModelValue: false,
  iModelDescription: undefined,
  iModelValueId: undefined,
};

export const entryScreenSlice = createSlice({
  name: "header",
  initialState,
  reducers: {
    setisUrlValid: (state, action: PayloadAction<boolean>) => {
      state.isUrlValid = action.payload;
    },
    setIsImodelValueDefined: (state, action: PayloadAction<boolean>) => {
      state.isImodelValueDefined = action.payload;
    },
    setCreateIModelValue: (state, action: PayloadAction<boolean>) => {
      state.createIModelValue = action.payload;
    },
    setIntelligentContent: (state, action: PayloadAction<boolean>) => {
      state.intelligentContent = action.payload;
    },
    setDefaultColor: (state, action: PayloadAction<string>) => {
      state.defaultColor = action.payload;
    },
    setIsCreatingIModelValue: (state, action: PayloadAction<boolean>) => {
      state.isCreatingIModelValue = action.payload;
    },
    setIModelDescription: (
      state,
      action: PayloadAction<string | undefined>,
    ) => {
      state.iModelDescription = action.payload;
    },
    setIModelValueId: (state, action: PayloadAction<number | undefined>) => {
      state.iModelValueId = action.payload;
    },
    resetIModelState: (state) => {
      state.isImodelValueDefined = initialState.isImodelValueDefined;
      state.iModelValueId = initialState.iModelValueId;
      state.iModelDescription = initialState.iModelDescription;
      state.intelligentContent = initialState.intelligentContent;
      state.createIModelValue = initialState.createIModelValue;
      state.isCreatingIModelValue = initialState.isCreatingIModelValue;
    },
  },
});

export const {
  setisUrlValid,
  setIsImodelValueDefined,
  setCreateIModelValue,
  setIntelligentContent,
  setDefaultColor,
  setIsCreatingIModelValue,
  setIModelDescription,
  setIModelValueId,
  resetIModelState,
} = entryScreenSlice.actions;

export const selectIsUrlValid = (state: RootState) =>
  state.entryScreen.isUrlValid;
export const selectIsImodelValueDefined = (state: RootState) =>
  state.entryScreen.isImodelValueDefined;
export const selectCreateIModelValue = (state: RootState) =>
  state.entryScreen.createIModelValue;
export const selectIntelligentContent = (state: RootState) =>
  state.entryScreen.intelligentContent;
export const selectDefaultColor = (state: RootState) =>
  state.entryScreen.defaultColor;
export const selectIsCreatingIModelValue = (state: RootState) =>
  state.entryScreen.isCreatingIModelValue;
export const selectIModelDescription = (state: RootState) =>
  state.entryScreen.iModelDescription;
export const selectIModelValueId = (state: RootState) =>
  state.entryScreen.iModelValueId;

export default entryScreenSlice.reducer;
